'use client';

import React from 'react';
import { Brightness4 as DarkIcon, Brightness7 as LightIcon } from '@mui/icons-material';
import { Box, IconButton, Tooltip, Typography, useTheme as useMuiTheme } from '@mui/material';

import { useTheme } from '@/contexts/ThemeContext';
import { useT } from '@/hooks';

export const FooterBottom = () => {
  const { mode, toggleTheme } = useTheme();
  const { t } = useT();
  const isDark = mode === 'dark';

  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: { xs: 'column', sm: 'row' },
        justifyContent: 'space-between',
        alignItems: 'center',
        gap: 2,
        py: 4,
        borderTop: '1px solid',
        borderColor: 'divider',
        mt: 4,
      }}
    >
      <Typography variant="caption" color="text.secondary" sx={{ opacity: 0.7 }}>
        {t('footer.copyright', { year: new Date().getFullYear() })}
      </Typography>

      <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
        <Typography variant="caption" color="text.secondary" sx={{ fontWeight: 500 }}>
          {isDark ? t('footer.darkMode') : t('footer.lightMode')}
        </Typography>
        <Tooltip title={isDark ? t('footer.switchToLight') : t('footer.switchToDark')}>
          <IconButton
            onClick={toggleTheme}
            size="small"
            sx={{
              color: isDark ? 'primary.main' : '#FBBF24',
              bgcolor: 'background.subtle',
              '&:hover': {
                bgcolor: 'background.paper',
                transform: 'rotate(15deg)',
              },
              transition: 'all 0.3s cubic-bezier(0.4, 0, 0.2, 1)',
              border: '1px solid',
              borderColor: 'divider',
            }}
          >
            {isDark ? <LightIcon fontSize="small" /> : <DarkIcon fontSize="small" />}
          </IconButton>
        </Tooltip>
      </Box>
    </Box>
  );
};
